// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-TabItem-module--cls1--3tfdw","cls2":"styles-TabItem-module--cls2--g8yDb styles-TabItem-module--cls1--3tfdw","isActive":"styles-TabItem-module--isActive--2OiV_"};